import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {PostalCodeViewModel} from "@app/presentation/pages/sign-up/steps/postal-code/postal-code.view-model";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";

@Component({
  selector: 'app-postal-code',
  templateUrl: './postal-code.component.html',
  styleUrls: ['../../sign-up.component.scss']
})
export class PostalCodeComponent implements OnInit{

  @Input() postalCodeControl:UntypedFormControl = new UntypedFormControl(null, Validators.required)

  postalCodeForm = new UntypedFormGroup({});

  private getPostalCodeStatus = createStatusStore();
  readonly isGetPostalCodeLoading$ = this.getPostalCodeStatus.isLoading$;

  constructor(
      private postalCodeViewModel:PostalCodeViewModel
  ) {
  }

  ngOnInit(): void {
    this.postalCodeForm.addControl('postalCode',this.postalCodeControl);
  }

  setPostalCodeFromCurrentLocation() {
    this.postalCodeViewModel.getPostalCodeFromCurrentLocation()
        .pipe(onIsLoadingChanges(this.getPostalCodeStatus.setIsLoading))
        .subscribe({
          next: postalCode => this.postalCodeControl.setValue(postalCode)
    });
  }

  @Input() isLoading?: boolean | null = false;

}
